import { handleClientError, getServiceResponse, ResponseCallback } from '../lib'

export const client = async <I, O>({
  url,
  method,
  headers,
  body,
  respCb,
  text,
  includeHeaders
}: {
  url: string
  method: 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE'
  headers: HeadersInit
  body?: I
  respCb?: ResponseCallback<O>
  text?: boolean
  includeHeaders?: boolean
}): Promise<O> => {
  try {
    const res: Response = await fetch(url, {
      method,
      headers,
      body: JSON.stringify(body)
    })

    const ret = respCb
      ? respCb(await getServiceResponse<O>(res, text))
      : await getServiceResponse<O>(res, text)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if(includeHeaders) {
      return {
        data: ret,
        headers: res.headers
      } as unknown as O //trickery when including headers - will need to improve later
    } else {
      return ret
    }
  } catch (e: any) {
    throw handleClientError(e)
  }
}
